<template>
    <b-modal :active.sync="show" id="ContractsRecordConfirmStopModal" aria-modal :width="600" :can-cancel="false">
        <div class="modal-card" style="width: auto">
            <b-loading :active.sync="loading" :is-full-page="false"></b-loading>

            <header class="modal-card-head"><p class="modal-card-title">{{ type == 'stop' ? 'Contract stoppen' : 'Contract verlengen' }}</p></header>
            <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                Weet je zeker dat {{ type == 'stop' ? 'je het contract wilt stoppen?' : 'je het contract wil verlengen?' }}
            </section>
            <footer class="modal-card-foot text-right">
                <button class="button" type="button" @click="$emit('closeConfirmStopModal')" :loading="loading">Annuleren</button>
                <button class="button is-success" @click="confirm" :loading="loading">Bevestigen</button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
import toastMixins from '@/mixins/toastMixins.js'
import endingContractMixin from '@/mixins/endingContractMixin.js'

export default {
    name: 'ContractsRecordConfirmStopModal',

    mixins: [toastMixins, endingContractMixin],

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        record: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            loading: false,
            depositProducts: [],
            creditExtraProducts: [],
            selectedEndDate: null,
            endPreview: null,
            hasAccess: false,
            showAccessMessage: false
        }
    },

    methods: {
                        confirm() {
            this.loading = true

            axios.post(`/api/contract/${this.$route.params.id}/stop-or-extend/${this.type}`, {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                let successMessage = ''
                let responseData = response.data

                // Handle different response types
                if (typeof responseData === 'string') {
                    // String responses like 'contractstopped', 'contractwillstop', 'extended'
                    if (responseData === 'contractstopped') {
                        successMessage = 'Contract is succesvol gestopt.'
                    } else if (responseData === 'contractwillstop') {
                        successMessage = 'Contract zal aflopen op de normale einddatum.'
                    } else if (responseData === 'extended') {
                        successMessage = 'Contract is succesvol verlengt en een nieuwe factuur wordt aangemaakt.'
                    }

                    // Show message and redirect
                    this.showMessage(successMessage)
                    this.loading = false
                    this.$emit('closeConfirmStopModal')
                    this.$router.push({name: 'ContractsOverview'})
                    return
                }

                // Handle JSON array response (products with deposits)
                const products = Array.isArray(responseData) ? responseData : []

                if (products.length > 0) {
                    console.log('Products found in response:', products)

                    // Set success message based on action type
                    if (this.type === 'stop') {
                        successMessage = 'Contract is succesvol gestopt.'
                    } else if (this.type.includes('extend')) {
                        successMessage = 'Contract is succesvol verlengt.'
                    }

                    this.showMessage(successMessage)

                    // Close the confirm modal
                    this.$emit('closeConfirmStopModal')

                    // Use the mixin to emit the showCreditInvoiceModal event
                    // The parent will handle opening the actual modal
                    this.$emit('showCreditInvoiceModal', {
                        products: products,
                        endDate: this.record?.step1?.end_date || null
                    })
                } else {
                    // Fallback for unexpected response format
                    this.showMessage('Contract is aangepast.')
                    this.$emit('closeConfirmStopModal')
                    this.$router.push({name: 'ContractsOverview'})
                }

                this.loading = false
            }).catch((e) => {
                console.error('Error in confirm stop/extend:', e)
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                this.loading = false
            })
        }
    }
}
</script>
